import axios from 'axios';

const baseApi = 'https://portfolio-backend-tousif.herokuapp.com/api/v1';
// const baseApi = 'http://localhost:5000/api/v1';

const axiosInstance = axios.create({
  baseURL: baseApi,
});

export default axiosInstance;
